interface ProviderInfo {
  provider: string;
  providerId: string | number;
}

export interface IRoommate {
  adminLocked: boolean;
  inSameRoom: boolean;
  firstName: string;
  lastName: string;
  userId: string;
  membershipId: string;
  previouslyKnown: boolean;
  source: "ADMIN" | " IMPORT" | "USER";
  matchCreationTime: number[];
}

export interface IFreeTextQuestion {
  questionId: string;
  questionOrder: number;
  questionText: string;
  placeholder: string;
  userAnswer: string;
}

export interface IAnswer {
  id: string;
  answerOrder: number;
  order: number;
  text?: string;
  answerText?: string;
}
export interface ISelectQuestion {
  answers: Record<string, IAnswer> | IAnswer[];
  disclaimerText: string;
  questionId: string;
  questionOrder: number;
  questionText: string;
  roommateAnswers: string[];
  userAnswers: string[];
}

export interface ISliderQuestion {
  answers: Record<string, IAnswer>;
  numberOfSliderOptions: number;
  questionId: string;
  questionOrder: number;
  questionText: string;
  roommateHighAnswers: number;
  roommateLowAnswers: number;
  userAnswers: number;
}

export interface ISocialAccount {
  type: "twitter" | "instagram" | "snapchat" | "youtube_channel" | "pinterest" | "tiktok";
  name: string;
}

export interface Major {
  id: number;
  name: string;
}

export interface House {
  id: number;
  name: string;
}

export interface IUser {
  userIdId: string;
  firstName: string;
  preferredFirstName?: string;
  preferredLastName?: string;
  preferredEmail?: string;
  lastName: string;
  claimedDate?: number[];
  createdDate?: number[];
  email: string;
  sex: string;
  uniqueId: string;
  leaseId: string;
  applicationId: string;
  registered: boolean;
  renewal: boolean;
  lastAccessDate: number[];
  l1Id: number;
  l2Id: number;
  l3Id: number;
  l4Id: number;
  roommates: IRoommate[];
  pastRoommates: IRoommate[];
  socialAccounts: ISocialAccount[];
  providerInfo: ProviderInfo[];
  userLifestyleQuestionsWithAnswers: {
    questions: {
      FREE_TEXT: IFreeTextQuestion[];
      SELECT: ISelectQuestion[];
      SLIDER: ISliderQuestion[];
    };
  };
  invitations: [];
  membershipId: string;
  userId: string;
  majors: Major[];
  housing: House[];
  questionsSaved: boolean;
}

export enum UNIT_GROUPING {
  UNIT_ID = "UNIT_ID",
  UNIT_SPACE_NUMBER = "UNIT_SPACE_NUMBER",
}

export enum SIGNED_APPLICATION_EVENT_TYPE {
  LEASE_SIGNED = "LeaseSigned"
}

export interface INetworkInvitation {
  url: string;
  id: string;
}

export type HOCType = <T = unknown>(Component: React.ComponentType<T>) => React.ComponentType<T>;
